<template>
    <button @click="onClick" :class="className" :disabled="enableNext">
        <slot />
    </button> 
</template> 


<script> 
export default { 
    name: 'CustomButton',
    data() {
        return {
            enableNext: false,
        }
    },
    props: {
        className: {
            type: String,
            default: 'app-btn-primary'
        },
    },
    methods: {
        async onClick() {
            if(this.enableNext){
                return false;
            }
            this.enableNext = true;
            await this.$emit('click');
            // this.enableNext = false;
            setTimeout(() => {
                this.enableNext = false;
            }, 500);
        }
    }
} 
</script>

<style scoped lang="scss">

button[disabled=disabled] {
    cursor: auto !important;
}
</style>